
import type { PropType } from 'vue'
import { computed, defineComponent } from 'vue'

import type { PaymentRequestsBalanceTransaction } from '@/modern/modules/m-accounting-module/services/types/payment-requests.types'

// > helpers/formatDate <
import formatDate from '@/modern/helpers/formatDate'

// > helpers/formatPriceToTenge <
import formatPriceToTenge from '@/modern/helpers/formatPriceToTenge'

export default defineComponent({
    components: {
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        failed: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: Boolean,
            default: false,
        },
        balance: {
            type: String as PropType<string | null>,
            default: null
        },
        transactionHistory: {
            type: Array as PropType<PaymentRequestsBalanceTransaction[]>,
            default: () => []
        }
    },
    emits: ['update:modelValue', 'close'],
    setup(props, { emit }) {
        const onClose = () => {
            if (props.disabled) return
            emit('close')
        }

        const onUpdateModelValue = (newValue: boolean) => {
            if (props.disabled) return
            emit('update:modelValue', newValue)
        }

        const isTopUpOperation = (transaction: PaymentRequestsBalanceTransaction) => {
            const balanceBefore = Number(transaction.balanceBefore)
            const balanceAfter = Number(transaction.balanceAfter)
            return balanceBefore < balanceAfter
        }

        return {
            formatDate,
            formatPriceToTenge,
            onClose,
            onUpdateModelValue,
            isTopUpOperation
        }
    }
})
